import { createAction } from '@reduxjs/toolkit';
import {
  FETCH_EVENTS_REQUEST,
  CREATE_EVENT_REQUEST,
  UPDATE_EVENT_REQUEST,
  DELETE_EVENT_REQUEST,
  FETCH_EVENT_DETAILS_REQUEST,
  FETCH_EVENT_DETAILS_SUCCESS,
  FETCH_EVENT_DETAILS_FAILURE,
  FETCH_EVENT_TICKETS_REQUEST,
  FETCH_EVENT_TICKETS_EXCEL_REQUEST,
  CREATE_EVENT_BOOKING_ORDER_REQUEST,
  VERIFY_EVENT_PAYMENT_REQUEST,
  RESET_EVENTS_STATE,
} from '../types/event';

import {
  FETCH_CATEGORIES_REQUEST,
  CREATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_REQUEST,
  DELETE_CATEGORY_REQUEST,
  FETCH_CATEGORY_DETAILS_REQUEST,
  RESET_CATEGORY_STATE,
} from '../types/category';

// Fetch Events
export const fetchEvents = (eventData = {}) => ({
  type: FETCH_EVENTS_REQUEST,
  payload: eventData,
});

export const fetchEventsTickets = (eventData = {}) => ({
  type: FETCH_EVENT_TICKETS_REQUEST,
  payload: eventData,
});
export const fetchEventsTicketsExcel = (eventData = {}) => ({
  type: FETCH_EVENT_TICKETS_EXCEL_REQUEST,
  payload: eventData,
});

export const createEventBookingOrder = data => ({
  type: CREATE_EVENT_BOOKING_ORDER_REQUEST,
  payload: { data },
});

export const verifyEventPayment = data => ({
  type: VERIFY_EVENT_PAYMENT_REQUEST,
  payload: { data },
});

export const createEvent = (eventData = {}) => ({
  type: CREATE_EVENT_REQUEST,
  payload: eventData,
});

// Update Event
export const updateEvent = ( eventData) => ({
  type: UPDATE_EVENT_REQUEST,
  payload: eventData ,
});

// Delete Event
export const deleteEvent = (eventId) => ({
  type: DELETE_EVENT_REQUEST,
  payload: eventId,
});

// Fetch Event Details
export const fetchEventDetails = (eventId) => ({
  type: FETCH_EVENT_DETAILS_REQUEST,
  payload: eventId,
});

export const fetchEventDetailsSuccess = (event) => ({
  type: FETCH_EVENT_DETAILS_SUCCESS,
  payload: event,
});

export const fetchEventDetailsFailure = (error) => ({
  type: FETCH_EVENT_DETAILS_FAILURE,
  payload: error,
});

// Reset State
export const resetEventsState = () => ({
  type: RESET_EVENTS_STATE,
});

export const fetchCategories = (categoryData) => ({
  type: FETCH_CATEGORIES_REQUEST,
  payload: categoryData,
});
export const fetchCategoryDetails = (categoryData) => ({
  type: FETCH_CATEGORY_DETAILS_REQUEST,
  payload: categoryData,
});

// Create Category
export const createCategory = ( categoryData) => ({
  type: CREATE_CATEGORY_REQUEST,
  payload:  categoryData ,
});

// Update Category
export const updateCategory = (categoryData) => ({
  type: UPDATE_CATEGORY_REQUEST,
  payload: { categoryData },
})

// Delete Category
export const deleteCategory = (categoryId) => ({
  type: DELETE_CATEGORY_REQUEST,
  payload: categoryId,
});

// Reset State
export const resetCategoryState = () => ({
  type: RESET_CATEGORY_STATE,
});